// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scroll-indicator[data-v-4b279df4]{height:100%;pointer-events:none;width:100%}.scroll-indicator[data-v-4b279df4] .float{height:100%}.scroll-indicator[data-v-4b279df4] .image{display:flex;justify-content:center;max-height:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
